/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Feature_FlagsInputs */

const en_svchip_feature_flags = /** @type {(inputs: Svchip_Feature_FlagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feature flags`)
};

const ar_svchip_feature_flags = /** @type {(inputs: Svchip_Feature_FlagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أعلام الميزات`)
};

const bn_svchip_feature_flags = /** @type {(inputs: Svchip_Feature_FlagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফিচার ফ্ল্যাগ`)
};

const de_svchip_feature_flags = /** @type {(inputs: Svchip_Feature_FlagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feature-Flags`)
};

const es_svchip_feature_flags = /** @type {(inputs: Svchip_Feature_FlagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indicadores de funciones`)
};

const fr_svchip_feature_flags = /** @type {(inputs: Svchip_Feature_FlagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indicateurs de fonctionnalités`)
};

const pt_svchip_feature_flags = /** @type {(inputs: Svchip_Feature_FlagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinalizadores de recursos`)
};

const zh_svchip_feature_flags = /** @type {(inputs: Svchip_Feature_FlagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`功能标志`)
};

const tr_svchip_feature_flags = /** @type {(inputs: Svchip_Feature_FlagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Özellik işaretleri`)
};

const ru_svchip_feature_flags = /** @type {(inputs: Svchip_Feature_FlagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Флаги функций`)
};

const pl_svchip_feature_flags = /** @type {(inputs: Svchip_Feature_FlagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flagi funkcji`)
};

/**
* | output |
* | --- |
* | "Feature flags" |
*
* @param {Svchip_Feature_FlagsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_feature_flags = /** @type {((inputs?: Svchip_Feature_FlagsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Feature_FlagsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_feature_flags(inputs)
	if (locale === "bn") return bn_svchip_feature_flags(inputs)
	if (locale === "de") return de_svchip_feature_flags(inputs)
	if (locale === "es") return es_svchip_feature_flags(inputs)
	if (locale === "fr") return fr_svchip_feature_flags(inputs)
	if (locale === "pt") return pt_svchip_feature_flags(inputs)
	if (locale === "zh") return zh_svchip_feature_flags(inputs)
	if (locale === "tr") return tr_svchip_feature_flags(inputs)
	if (locale === "ru") return ru_svchip_feature_flags(inputs)
	if (locale === "pl") return pl_svchip_feature_flags(inputs)
	return en_svchip_feature_flags(inputs)
});